import { render, staticRenderFns } from "./WrappingDiscard.vue?vue&type=template&id=52ecf8ca"
import script from "./WrappingDiscard.vue?vue&type=script&lang=js"
export * from "./WrappingDiscard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports